import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/Footer';
import './ICAIMPage.css';

const stats = [
  { value: '91', label: 'Research Papers', detail: 'High-quality papers on interdisciplinary subjects', icon: 'document' },
  { value: 'Hybrid', label: 'Conference Mode', detail: 'Blended participation (Virtual & In-person)', icon: 'group' },
  { value: '4+', label: 'Global Partners', detail: 'AMC, MMA, GIST, and NCSH', icon: 'globe' },
  { value: '150+', label: 'Attendees', detail: 'Robust participation in medical sessions', icon: 'user' },
  { value: 'AI for Bharat@100', label: 'Vision Focus', detail: 'Sustainability in agriculture & healthcare', icon: 'eye' },
];

const heroHighlights = ['AI for Bharat@100', 'Sustainable Agriculture', 'Responsible AI in Healthcare', 'Generative AI', 'Data Protection Law'];

const themes = [
  {
    title: 'Agriculture',
    description: 'AI-assisted digital solutions, precision agriculture, drones, and AI-enabled ecosystems for climate-resilient farming.',
    tone: 'green',
  },
  {
    title: 'Healthcare',
    description: 'Responsible AI, hospital digitization, ethical AI use, data privacy, and tools for smarter clinics.',
    tone: 'blue',
  },
  {
    title: 'Information Technology',
    description: 'Generative AI, DPDP Act compliance, problem-solving hackathons, and emerging technologies.',
    tone: 'violet',
  },
];

const preConferenceSchedule = [
  { date: '04-02-2026', time: 'Bootcamp', topic: 'Generative AI in Action & IBM SkillBuild', speaker: 'Ms. Jyoti Aggarwal & Mr. Aman Jain' },
  { date: '06-02-2026', time: 'Hackathon', topic: 'Gen AI Hackathon Initiative – "GenAI Ignite Project"', speaker: 'Judges: Mr. Malav Shah, Mr. Ravi Sharma' }
];

const sessionChairs = [
  'Dr. Rashmita Pradhan, Associate Professor, Late Bhausaheb Hiray S.S. Trust’s Institute of Computer Application.',
  'Dr. (Mrs.) Sulakshana Kishor Vispute, Academic Coordinator, MCA Department, DES NMITD'
];

const paperAwards = [
  { category: 'Student - First Winner', title: 'AgriVaani: Bridging Indigenous Agricultural Wisdom with Modern AI for Knowledge Preservation and Rural Inclusivity in AgriTech in India', authors: 'Sanjana J. Redekar, Ms. Rohini Bagul' },
  { category: 'Student - First Runner up', title: 'Predicting Student Placement Readiness: A Machine Learning Approach Using Coding Activities and Multi-Dimensional Performance Indicators', authors: 'Priyanshu Chouhan, Swapnil Borkar, Ms. Sonu Gupta' },
  { category: 'Student - Second Runner up', title: 'A Study on the Ethical Implications and Data Privacy Challenges in the Age of Artificial Intelligence', authors: 'Shardul Kolte, Saurabh Kumar, Prof. Mr. Shirshendu Maitra' },
];

const posterAwards = [
  { category: 'Student - First Winner', title: 'Kisan Suraksha: Leveraging AI for Farmer Safety, Awareness, and Economic Stability', authors: 'Adarsh Dubey, Aryan Gaur, Shresha Ghadi, Devesh Ghadigaonkar, Atish Ghanekar' },
  { category: 'Student - First Runner up', title: 'SWIFT PASS – Smart Ambulance Detection & Priority Traffic Signal System', authors: 'Utkarsh Pandey, Pranjal Pardeshi, Shruti Pardeshi, Khushbu Patekar, Aryan Patel, Rakesh' },
  { category: 'Student - Second Runner up', title: 'AgroVision: AI-Driven Crop Disease Detection for Sustainable Agriculture', authors: 'Soham Naik, Aniket Nalegaonkar, Anurag Nikumbh, Adityakumar Pal, Anand Pal, Prince Pal, Jyoti Yadav' },
];

const hackathonAwards = [
  { category: 'Student - First Winner', title: 'Privacy Guard – Permission Abuse Analyzer', authors: 'GenAI Ignite Project' },
  { category: 'Student - First Runner up', title: 'A System for User-Scoped Intelligence', authors: 'GenAI Ignite Project' },
  { category: 'Student - Second Runner up', title: 'Raxa: Early Disease Detection & Health Risk Assessment', authors: 'GenAI Ignite Project' },
];


const partners = ['AMC', 'MMA', 'GIST', 'NCSH'];
const galleryCards = [
  { title: 'Inauguration Ceremony', src: '/ICAIM/ICAIM2026/_MCA4270.jpg' },
  { title: 'Keynote Speakers', src: '/ICAIM/ICAIM2026/_MCA4339.jpg' },
  { title: 'Panel Discussion', src: '/ICAIM/ICAIM2026/_MCA4429.jpg' },
  { title: 'Doctor\'s Workshop', src: '/ICAIM/ICAIM2026/_MCA4862.jpg' },
  { title: 'Hackathon Winners', src: '/ICAIM/ICAIM2026/_MCA4715.jpg' }
];
const carouselImages = [
  '/ICAIM/ICAIM2026/_MCA4393.JPG',
  '/ICAIM/ICAIM2026/_MCA4270.JPG',
  '/ICAIM/ICAIM2026/_MCA4375.JPG',
  '/ICAIM/ICAIM2026/_MCA4285.JPG',
  '/ICAIM/ICAIM2026/20260208_110832amByGPSMapCamera.jpg',
];

const icon = (kind) => {
  const common = { fill: 'none', stroke: 'currentColor', strokeWidth: '1.9', strokeLinecap: 'round', strokeLinejoin: 'round' };
  if (kind === 'calendar') return <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" {...common} /><path d="M8 3v4M16 3v4M3 10h18" {...common} /></svg>;
  if (kind === 'location') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.4 6-11a6 6 0 1 0-12 0c0 5.6 6 11 6 11Z" {...common} /><circle cx="12" cy="10" r="2.5" {...common} /></svg>;
  if (kind === 'document') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l4 4v14H7V3Z" {...common} /><path d="M14 3v5h5M10 13h6M10 17h6M10 9h2" {...common} /></svg>;
  if (kind === 'user') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4" {...common} /><path d="M5 21c1.2-4 4-6 7-6s5.8 2 7 6" {...common} /></svg>;
  if (kind === 'globe') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" {...common} /><path d="M3 12h18M12 3c2.2 2.4 3.3 5.4 3.3 9S14.2 18.6 12 21M12 3c-2.2 2.4-3.3 5.4-3.3 9S9.8 18.6 12 21" {...common} /></svg>;
  if (kind === 'group') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="9" r="3.2" {...common} /><circle cx="17" cy="10" r="2.6" {...common} /><path d="M3.5 21c.9-3.9 3-6 5.5-6s4.6 2.1 5.5 6M14.5 16c2.4.2 4.2 1.9 5 5" {...common} /></svg>;
  if (kind === 'eye') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.6-6 9.5-6 9.5 6 9.5 6-3.6 6-9.5 6-9.5-6-9.5-6Z" {...common} /><circle cx="12" cy="12" r="3" {...common} /></svg>;
  if (kind === 'arrow') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" {...common} /></svg>;
  if (kind === 'leaf') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 14c0-5.5 4.5-10 10-10h4v4c0 5.5-4.5 10-10 10H5v-4Z" {...common} /><path d="M8 16c3-5 6-7 11-10" {...common} /></svg>;
  if (kind === 'medical') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2" {...common} /><path d="M12 8v8M8 12h8" {...common} /></svg>;
  if (kind === 'chip') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2" {...common} /><path d="M9 1v4M15 1v4M9 19v4M15 19v4M1 9h4M1 15h4M19 9h4M19 15h4" {...common} /></svg>;
  if (kind === 'download') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" {...common} /></svg>;
  return null;
};

const Icaim26 = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  const handleScrollToSection = (event, sectionId) => {
    event.preventDefault();
    const target = document.getElementById(sectionId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="icaim25Page icaim24Page">
      <Navbar />
      <main className="icaim25Main">
        <section className="icaim25Hero">
          <div className="icaim25HeroShell glass-panel-dark">
            <div className="icaim25HeroGrid" id="icaim25-content">
              <div className="icaim25HeroCopy">
                <span className="icaim25HeroKicker">ICAIM 2026</span>
                <h1 className="icaim25HeroTitle">
                  Advances in IT &amp; Management
                </h1>
                <p className="icaim25HeroSubtitle">
                  Theme: "Leveraging Information for Sustainability in Agriculture & Healthcare – AI for Bharat@100"
                </p>

                <div className="icaim25HeroHighlights" aria-label="Conference focus areas">
                  {heroHighlights.map((highlight) => (
                    <span key={highlight}>{highlight}</span>
                  ))}
                </div>

                <div className="icaim25HeroMetaInline">
                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('calendar')}</span>
                    <span>7 - 8 February 2026</span>
                  </div>

                  <span className="icaim25MetaSeparator">|</span>

                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('location')}</span>
                    <span>TIMSCDR, Mumbai (Blended Mode)</span>
                  </div>
                </div>

                <div className="icaim25HeroActions">
                  <a
                    href="#overview"
                    className="icaim25PrimaryButton text-center"
                    style={{ textDecoration: 'none' }}
                    onClick={(event) => handleScrollToSection(event, 'overview')}
                  >
                    <span>Explore Conference</span>
                    <span className="icaim25ButtonIcon">{icon('arrow')}</span>
                  </a>
       <a
                    href="/pdf/ICAIM/ICAIM 2026 INDEXPAGE.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icaim25SecondaryButton text-center"
                    style={{ textDecoration: 'none' }}
                  >
                    <span>View Publications</span>
                    <span className="icaim25ButtonIcon">{icon('document')}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25StatsSection" id="about">
          <div className="icaim25StatsGrid glass-panel-light">
            {stats.map((stat, index) => (
              <div className="icaim25StatCard" key={stat.label}>
                <div className={`icaim25StatIcon statTone${index + 1}`}>{icon(stat.icon)}</div>
                <div>
                  <div className="icaim25StatValue">{stat.value}</div>
                  <div className="icaim25StatLabel">{stat.label}</div>
                  <div className="icaim25StatDetail">{stat.detail}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25AboutSection" id="overview">
          <div className="icaim25AboutGrid">
            <div className="icaim25SectionIntro">
              <span className="icaim25SectionTag">Conference Overview</span>
              <h2>Pioneering AI for Bharat@100.</h2>
              <p>
                Thakur Institute of Management Studies, Career Development and Research (TIMSCDR) organized <strong>ICAIM 2026</strong> on 7-8 February 2026. This blended conference aimed to contribute towards the vision of <strong>AI for Bharat@100</strong> by driving innovative IT solutions for sustainability and resilience in agriculture and healthcare.
              </p>
              <p>
                In association with AMC, MMA, GIST, and NCSH, the event focused on how advanced IT solutions, Generative AI, and ethical frameworks can enhance productivity, inclusivity, and efficiency, contributing to the development of a future-ready India.
              </p>
            </div>

            <div className="icaim25StageCard glass-panel-light" aria-hidden="true">
             
              <div className="icaim25StageScreen">
                <div className="icaim25CarouselTrack">
                  {carouselImages.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Conference slide ${index + 1}`}
                      className={`icaim25CarouselImg ${index === currentSlide ? 'active' : ''}`}
                    />
                  ))}
                
                </div>
                <div className="icaim25StageAudience" />
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25ThemeSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Theme Focus</span>
          </div>
          <div className="icaim25ThemeGrid">
            {themes.map((theme, index) => (
              <article className={`icaim25ThemeCard tone-${theme.tone}`} key={theme.title}>
                <div className="icaim25ThemeCardIcon">
                  {icon(index === 0 ? 'leaf' : index === 1 ? 'medical' : 'chip')}
                </div>
                <h3>{theme.title}</h3>
                <p>{theme.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="icaim25NarrativeSection" id="events">
          <div className="icaim25CenteredHeading" style={{ marginTop: '50px' }}>
            <span className="icaim25SectionTag">Event Highlights</span>
          </div>
          <div className="icaim25NarrativeGrid">
            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 1 - 7 February 2026</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>AI in Agriculture</h3>
              </div>
              <p>
                Inaugurated by Chief Guest <strong>Prof. Dr. Indra Mani</strong> (Vice-Chancellor, Vasantrao Naik Marathwada Krishi Vidyapeeth) and <strong>Dr. Sujeet Kumar Shukla</strong>. The sessions heavily emphasized sustainability for a developed India.
              </p>
              <p>
                <strong>Gaurav Jha</strong> (Kansas State University) delivered a lecture on AI-assisted digital solutions using sensing tech and drones. <strong>Dr. Amol V. Dahiphale</strong> spoke on AI for Smart Agronomy, while <strong>Mr. Vijay Kolekar</strong> discussed the digital ecosystem for climate-resilient agriculture.
              </p>
              <p>
                A thought-provoking panel on <em>"AI for Bharat@100: Issues & Challenges in Indian Agriculture"</em> highlighted practical entry points for students to contribute to the AgriTech sector immediately.
              </p>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 2 - 8 February 2026</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Responsible AI in Healthcare</h3>
              </div>
              <p>
                Graced by Chief Guest <strong>Dr. Rajiv Agrawal</strong> (President, AMC). <strong>Dr. Prashant Kerkar</strong> stressed that AI should support, not replace, clinicians. <strong>Dr. Rakhi Agrawal</strong> detailed the lifecycle of hospital digitization, and <strong>Dr. Santosh Chapaneri</strong> focused on ethical AI use.
              </p>
              <p>
                <strong>Dr. Aashish Mody</strong> demonstrated productivity-enhancing apps for surgeons. The day concluded with a critical panel on Data Protection Law (DPDP Act) and the Ethical Use of AI in Healthcare featuring Mr. Vivek Tiwari, Dr. Alok Modi, and Prof. Sonu Gupta.
              </p>
            </article>
          </div>
        </section>

        <section className="icaim25FeatureSection" id="speakers">
          <div className="icaim25FeatureGrid">
            <article className="icaim25DarkPanel glass-panel-dark">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag">Workshops &amp; Special Events</span>
                <h2>Applied learning and skill development.</h2>
              </div>
              <div className="icaim25WorkshopGrid">
                <div className="icaim25WorkshopCard highlight-green">
                  <h3>Doctor&apos;s Workshop</h3>
                  <p>AI Tools for Smarter Clinics and Patient Engagement.</p>
                  <ul>
                    <li>AI Prompting Techniques for Doctors</li>
                    <li>AI as Medical Content Co-Creator</li>
                    <li>Digital Marketing & Ethical Patient Outreach</li>
                    <li>Clinic Management & Operational Efficiency</li>
                  </ul>
                </div>
                <div className="icaim25WorkshopCard highlight-orange">
                  <h3>Pre-Conference Bootcamps & Hackathon</h3>
                  <p>Hands-on sessions on Generative AI and problem-solving.</p>
                  <div className="icaim25JudgesBlock">
                    <strong>Highlights</strong>
                    <span>Generative AI in Action (IBM SkillBuild Onboarding)</span>
                    <span>Gen AI Hackathon Initiative: "GenAI Ignite Project"</span>
                    <span>Judged by Mr. Malav Shah and Mr. Ravi Sharma</span>
                  </div>
                </div>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light" id="pre-conference">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-primary)' }}>Pre-Conference</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Student Sessions</h3>
              </div>
              <p style={{ marginBottom: '16px' }}>
                Conducted by eminent personalities to prepare students with cutting-edge skills in Generative AI.
              </p>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Date / Time</th>
                      <th>Topics</th>
                      <th>Speaker / Judges Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {preConferenceSchedule.map((session, i) => (
                      <tr key={i}>
                        <td><strong>{session.date}</strong><br /><span style={{ fontSize: '0.85em', color: 'var(--icaim-text-muted)' }}>{session.time}</span></td>
                        <td>{session.topic}</td>
                        <td>{session.speaker}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        <section className="icaim25ResearchSection" id="awards">
          <div className="icaim25CenteredHeading" style={{ marginTop: '80px' }}>
            <span className="icaim25SectionTag">Proceedings & Recognitions</span>
            <h2 style={{ fontSize: '2.2rem', marginTop: '10px' }}>91 Research Papers (ISBN: 978-81-997623-3-6)</h2>
            <p style={{ color: 'var(--icaim-text-muted)', maxWidth: '700px', margin: '10px auto' }}>
              Selected after a rigorous review process, emphasizing inclusive growth, ethical AI, and interdisciplinary research aligned with national goals like AI for Bharat@100.
            </p>
          </div>

          <div className="icaim25SessionChairs" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginBottom: '40px' }}>
            {sessionChairs.map((chair, i) => (
              <span key={i} className="icaim25Badge">{chair}</span>
            ))}
          </div>

          <div className="icaim25AwardsStack">
            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>Research Paper Awards</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Award Category</th>
                      <th>Research Paper Title</th>
                      <th>Authors</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paperAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.category.includes('First Winner') ? 'var(--icaim-accent)' : 'inherit' }}>{award.category}</strong></td>
                        <td>{award.title}</td>
                        <td>{award.authors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>Technical Research Poster Awards</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Award Category</th>
                      <th>Poster Title</th>
                      <th>Authors</th>
                    </tr>
                  </thead>
                  <tbody>
                    {posterAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.category.includes('First Winner') ? 'var(--icaim-accent)' : 'inherit' }}>{award.category}</strong></td>
                        <td>{award.title}</td>
                        <td>{award.authors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>GenAI Ignite Project Hackathon Winners</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Award Category</th>
                      <th>Hackathon Topic / Project</th>
                      <th>Event</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hackathonAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.category.includes('First Winner') ? 'var(--icaim-accent)' : 'inherit' }}>{award.category}</strong></td>
                        <td>{award.title}</td>
                        <td>{award.authors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        {/* <section className="icaim25PublicationsSection" id="publications" style={{ padding: '60px 20px', background: 'var(--icaim-bg-alt)' }}>
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Publications</span>
            <h2 style={{ fontSize: '2rem', marginTop: '10px' }}>List of Journal Publication for ICAIM - 2026</h2>
            <p style={{ color: 'var(--icaim-text-muted)', maxWidth: '600px', margin: '15px auto 30px' }}>
              Access the official published book featuring 91 outstanding interdisciplinary research papers (ISBN: 978-81-997623-3-6) and technical posters from the ICAIM 2026 conference.
            </p>
            <a 
              href="/pdf/ICAIM/ICAIM 2026 INDEXPAGE.pdf" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="icaim25PrimaryButton" 
              style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
            >
              <span className="icaim25ButtonIcon" style={{ margin: 0 }}>{icon('download')}</span>
              <span>Download Published Book (PDF)</span>
            </a>
          </div>
        </section> */}

        <section className="icaim25PartnersSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Our Partners &amp; Associations</span>
          </div>
          <div className="icaim25PartnersGrid">
            {partners.map((partner) => (
              <div className="icaim25PartnerCard glass-panel-light" key={partner}>
                <div className="icaim25PartnerMark">{partner.charAt(0)}</div>
                <div className="icaim25PartnerName">{partner}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25GallerySection" id="gallery">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Glimpses From ICAIM 2026</span>
          </div>
          <div className="icaim25GalleryGrid">
            {galleryCards.map((card, index) => (
              <div className={`icaim25GalleryCard gallery-${index + 1}`} key={card.title}>
                <img
                  src={card.src}
                  alt={card.title}
                  style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <span>{card.title}</span>
              </div>
            ))}
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
};

export default Icaim26;